import { CommonModule } from '@angular/common';
import { ElementRef, inject } from "@angular/core";
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { PageFacade } from "@core/frontend-shared";
import { ConfigService } from "@core/shared/config";
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { skipWhile, take } from "rxjs/operators";
import { MaintenanceFacade, MaintenanceState } from "../state/maintenance.state";
import * as i0 from "@angular/core";
import * as i1 from "../state/maintenance.state";
import * as i2 from "@core/shared/config";
import * as i3 from "@core/frontend-shared";
import * as i4 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
import * as i5 from "../../../../../ui/frontend-shared/src/lib/button/button";
import * as i6 from "../../../../../ui/frontend-shared/src/lib/logo/logo";
import * as i7 from "@angular/common";
const _c0 = ["logoContent"];
function MaintenanceModeComponent_Conditional_0_Conditional_0_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtext(2, "Weitere Informationen:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx);
  }
}
function MaintenanceModeComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 2)(2, "div", 3);
    i0.ɵɵelement(3, "ui-logo", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div")(5, "h3", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h1", 5);
    i0.ɵɵtext(8, "Wartungsmodus aktiv!");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 6)(10, "p");
    i0.ɵɵtext(11, "Aktuell ist die Seite im Wartungsmodus.");
    i0.ɵɵelement(12, "br");
    i0.ɵɵtext(13, " Bitte versuchen Sie es etwas sp\u00E4ter erneut.");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(14, MaintenanceModeComponent_Conditional_0_Conditional_0_Conditional_14_Template, 5, 1, "div");
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 7)(17, "button", 8);
    i0.ɵɵlistener("click", function MaintenanceModeComponent_Conditional_0_Conditional_0_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClickReload());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("scaling", 100);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.pageTitle);
    i0.ɵɵadvance(8);
    i0.ɵɵconditional((tmp_5_0 = i0.ɵɵpipeBind1(15, 3, ctx_r1.text$)) ? 14 : -1, tmp_5_0);
  }
}
function MaintenanceModeComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "ui-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "wrench");
  }
}
function MaintenanceModeComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MaintenanceModeComponent_Conditional_0_Conditional_0_Template, 18, 5, "div", 0);
    i0.ɵɵconditionalCreate(1, MaintenanceModeComponent_Conditional_0_Conditional_1_Template, 2, 1, "div", 1);
  }
  if (rf & 2) {
    const state_r3 = ctx;
    i0.ɵɵconditional(state_r3.enabled && !state_r3.whitelisted ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.enabled && state_r3.whitelisted ? 1 : -1);
  }
}
export let MaintenanceModeComponent = /*#__PURE__*/(() => {
  class MaintenanceModeComponent {
    constructor(facade, config, page) {
      this.facade = facade;
      this.config = config;
      this.page = page;
      this.whitelisted$ = inject(Store).select(MaintenanceState.whitelisted);
      this.enabled$ = inject(Store).select(MaintenanceState.maintenanceModeEnabled);
      this.text$ = inject(Store).select(MaintenanceState.maintenanceModeText);
      this.state$ = combineLatest({
        whitelisted: this.whitelisted$,
        enabled: this.enabled$
      });
      this.pageTitle = config.get('pageTitle');
      this.state$.pipe(skipWhile(state => !state.enabled), take(1)).subscribe(state => {
        page.setTitle('Wartungsmodus aktiv!');
        page.setMeta([{
          name: 'robots',
          content: 'noindex,nofollow'
        }]);
      });
    }
    onClickReload() {
      window.location.reload();
    }
    static {
      this.ɵfac = function MaintenanceModeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaintenanceModeComponent)(i0.ɵɵdirectiveInject(i1.MaintenanceFacade), i0.ɵɵdirectiveInject(i2.ConfigService), i0.ɵɵdirectiveInject(i3.PageFacade));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MaintenanceModeComponent,
        selectors: [["maintenance-mode"]],
        viewQuery: function MaintenanceModeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logoRef = _t.first);
          }
        },
        decls: 2,
        vars: 3,
        consts: [[1, "overlay"], [1, "summ"], [1, "infobox"], [1, "logowrapper"], ["background", "true", "id", "logo", 3, "scaling"], [1, "ui-margin-remove"], [1, "infotext"], [1, "ui-margin"], ["uiButton", "", "label", "Seite neu laden", 3, "click"], ["size", "2x", "title", "Wartungsmodus aktiv!", 3, "icon"]],
        template: function MaintenanceModeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MaintenanceModeComponent_Conditional_0_Template, 2, 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.state$)) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [CommonModule, MinimalUiModule, i4.UiIconComponent, i5.UiButtonComponent, i6.UiLogoComponent, i7.AsyncPipe],
        styles: [".overlay[_ngcontent-%COMP%]{position:fixed;inset:0;z-index:9998;background:var(--backgroundColor);transition:background-color .3s}.overlay[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.infobox[_ngcontent-%COMP%]{background:var(--contentColor);color:var(--textColor);padding:20px;width:600px;max-width:90%;position:relative}.infotext[_ngcontent-%COMP%]{margin:30px 0}.logowrapper[_ngcontent-%COMP%]{position:absolute;width:100px;right:0;top:0}.summ[_ngcontent-%COMP%]{position:fixed;inset:0;z-index:9998;border:5px solid var(--maintenanceWarningColor);pointer-events:none}.summ[_ngcontent-%COMP%]   ui-icon[_ngcontent-%COMP%]{color:var(--maintenanceWarningColor);position:absolute;top:15px;left:75px}"]
      });
    }
  }
  return MaintenanceModeComponent;
})();